import allowed from '@/core/constants/allowed-roles.constant.js'

const routes = [
  {
    name: 'Target Scheduling',
    path: '/target-scheduling',
    meta: {
      requiresAuth: true,
      allowedRoles: [...allowed.target_scheduling.roles],
      layout: 'home',
      module: 'target-scheduling',
    },
    children: [
      {
        name: 'Target Scheduling Home',
        path: '',
        allowedRoles: [...allowed.target_scheduling_home.roles],
        component: () =>
          import(
            '@/modules/target-scheduling/containers/target-scheduling/target-scheduling.container.vue'
          ),
      },
      {
        name: 'SPI Goals',
        path: 'spi-goals',
        meta: {
          allowedRoles: [...allowed.spi_goals.roles],
        },
        component: () =>
          import(
            '@/modules/target-scheduling/containers/spi-goals/spi-goals.container.vue'
          ),
      },
      {
        name: 'Safety Observation Goals',
        path: 'safety-observation-goals',
        meta: {
          allowedRoles: [...allowed.safety_observation_goals.roles],
        },
        component: () =>
          import(
            '@/modules/target-scheduling/containers/safety-observation-goals/safety-observation-goals.container.vue'
          ),
      },
      {
        name: 'Safety Observation Groups',
        path: 'safety-observation-goals/safety-group',
        meta: {
          allowedRoles: [...allowed.safety_observation_goals.roles],
        },
        component: () =>
          import(
            '@/modules/target-scheduling/containers/safety-group/safety-group.container.vue'
          ),
      },
      {
        name: 'Leave Management',
        path: 'leave-management',
        meta: {
          allowedRoles: [...allowed.safety_observation_goals.roles],
        },
        component: () =>
          import(
            '@/modules/target-scheduling/containers/leave-management/leave-management.container.vue'
          ),
      },
    ],
  },
]

export default routes
